// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__Y10E2","signatureButtonsRight":"ModalSign_signatureButtonsRight__3IZah"};